import React from "react";
import { TextInput, View, Keyboard } from "react-native";
import t from "@constants/localization";
import Label from "../SupportTree/components/Label";
import { verticalScale, scale } from "../../utils/scale";

const PATH = "screens/OrderDetails/EditText";

const TextArea = ({ value, onSubmit, formItem = {} }) => {
  const { label } = formItem;
  return (
    <>
      <Label label={label} />
      <View
        style={{
          height: scale(80),
          borderRadius: 6,
          borderWidth: 1,
          borderColor: "#e6e6e6f0",
          marginTop: 5,
          paddingHorizontal: 5,
        }}
      >
        <TextInput
          value={value}
          placeholder={t(`${PATH}/typeHere`)}
          multiline
          onBlur={() => Keyboard.dismiss()}
          numberOfLines={3}
          onSubmitEditing={() => Keyboard.dismiss()}
          onChangeText={onSubmit}
          style={{
            fontSize: 14,
          }}
        />
      </View>
    </>
  );
};

export default TextArea;
